import { registerMessage } from './registry';
import { BookOpenIcon } from '../../components/icons';

export const HELP_POINTER_MESSAGE = registerMessage({
  slug: 'help-pointer-v1',
  chrome: 'help',
  pages: [
    {
      title: 'Need Help?',
      icon: (
        <BookOpenIcon className="w-16 h-16 text-neon-blue-400" />
      ),
      content: (
        <p className="text-neon-blue-200">
          Click the{' '}
          <span className="text-yellow-400 font-pixel">
            Help
          </span>{' '}
          button in realm menu to learn how Choreboard
          works!
        </p>
      ),
    },
  ],
  buttons: {
    primary: { label: 'Got it!', action: () => {} },
  },
});
